import React from 'react';
import { Button, Select, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchRelationshipSearch, fetchRelationshipSearchData, } from '../../appRedux/actions/Common';
import { createDebounce } from '../../util/methods';

class SearchFilter extends React.Component {
  state = {
    value: []
  };

  componentDidMount() {
    //if(this.props.data && this.props.data.field === 'status' && this.props.resourceName === 'JobCard') {
    //  this.props.handleFilter('Open', this.props.confirm, this.props.data);
    //}
  }

  componentWillReceiveProps(nextProps) {
  }

  debouncedSearch = createDebounce((value) => {
    console.log('F Searching for:', value);
    const { data, resourceName } = this.props;
    // this.props.searchAssetParameter(searchValue);
    if (data.filterField === 'presentStatus') {
      this.props.fetchRelationshipSearchData(value, resourceName, data.filterField);
    } else {
      this.props.fetchRelationshipSearchData(value, resourceName, data.field);
    }
  }, 400); // Adjust the delay (in milliseconds) as needed

  handleSearch = value => {
    this.debouncedSearch(value);
    // const {data, resourceName} = this.props;
    // if(data.filterField === 'presentStatus') {
    //   this.props.fetchRelationshipSearchData(value, resourceName, data.filterField);
    // } else {
    //   this.props.fetchRelationshipSearchData(value, resourceName, data.field);
    // }
  };

  handleChange = value => {
    this.setState({ value });
    this.props.setSelectedKeys(value ? [value] : []);

    setTimeout(() => {
      this.props.fetchRelationshipSearch();
    }, 200);
  };

  searchClicked = (selectedKeys, confirm, data) => {
    this.setState({ value: [] });
    this.props.handleFilter(selectedKeys, confirm, data);
  }

  resetClicked = (clearFilters, data) => {
    this.setState({ value: [] });
    this.props.handleReset(clearFilters, data);
  }

  render() {
    const { setSelectedKeys, handleFilter, selectedKeys, confirm, data, clearFilters, handleReset, searchData } = this.props;
    const filteredData = searchData ? Object.values(searchData.reduce((acc, cur) => Object.assign(acc, { [cur[data.field]]: cur }), {})) : [];
    return (
      <div style={{ padding: 8 }}>
        {
          data.filterField && data.filterField === 'presentStatus' ?
            <Select
              showSearch
              mode='multiple'
              value={this.state.value}
              placeholder={''}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={this.handleSearch}
              onChange={this.handleChange}
              notFoundContent={null}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            >
              {searchData && searchData.length && searchData.map(item => {
                return <Select.Option key={item._id} value={item['name']}><Tooltip
                  title={item['name']}>{item['name']}</Tooltip></Select.Option>
              })}
            </Select> :
            <Select
              showSearch
              mode='multiple'
              value={this.state.value}
              placeholder={''}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={this.handleSearch}
              onChange={this.handleChange}
              notFoundContent={null}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            >
              {filteredData && filteredData.length && filteredData.map(item => {
                let fieldTitle = item[data.field];
                if (this.props.resourceName === 'JobCard') {
                  if (fieldTitle === 'ClosedPendingInvoice') {
                    fieldTitle = 'Closed - Pending Invoice';
                  } else if (fieldTitle === 'ClosedPendingInvoiceReopen') {
                    fieldTitle = 'Reopened - Pending Invoice';
                  } else if (fieldTitle === 'Closed' || fieldTitle === 'Open') {
                    return null; // Skip these options
                  } else {
                    fieldTitle = fieldTitle;
                  }
                }
                return <Select.Option key={item._id} value={item[data.field]}><Tooltip
                  title={fieldTitle}>{fieldTitle}</Tooltip></Select.Option>
              })}
            </Select>}
        <Button
          type="primary"
          onClick={() => this.searchClicked(selectedKeys, confirm, data)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.resetClicked(clearFilters, data)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    );
  }
}

SearchFilter.defaultProps = {};

SearchFilter.propTypes = {
  data: PropTypes.object,
  handleFilter: PropTypes.func,
  handleReset: PropTypes.func,
  setSelectedKeys: PropTypes.func,
  selectedKeys: PropTypes.array,
  confirm: PropTypes.func,
  clearFilters: PropTypes.func,
  fetchRelationshipSearch: PropTypes.func,
  fetchRelationshipSearchData: PropTypes.func,
};


const mapStateToProps = ({ commonData }) => {
  return {
    filters: commonData.filters,
    modules: commonData.modules,
    searchData: commonData.relationshipSearch
  };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchRelationshipSearch,
    fetchRelationshipSearchData
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(SearchFilter);
